import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureTelegramIdFromUrl } from "@/lib/telegramId";

/**
 * Невидимый компонент: на каждом изменении маршрута проверяет URL на
 * параметр `?user_id=` и сохраняет Telegram ID в localStorage (TTL 14 дней).
 * Должен рендериться внутри <BrowserRouter>.
 */
export const TelegramIdCapture = () => {
  const location = useLocation();

  useEffect(() => {
    captureTelegramIdFromUrl();
  }, [location.pathname, location.search]);

  return null;
};
